export default function validateIdentity(identity: string) {
  const re = /^[a-zA-Z0-9_]*$/;
  return re.test(String(identity));
}
